// const Drawer = ({
//   isOpen,
//   onClose,
//   title,
//   description,
//   children,
//   footer,
//   width = "max-w-[400px]",
// }) => {
//   if (!isOpen) return null;

//   return (
//     <>
//       {/* Overlay */}
//       <div
//         className="fixed inset-0 bg-black/30 dark:bg-black/50 z-[998]"
//         // onClick={onClose}
//       />

//       {/* Drawer Panel */}
//       <div
//         className={`fixed top-0 right-0 h-screen w-full ${width} bg-white dark:bg-gray-900 text-slate-900 dark:text-slate-100 z-[999] border-l border-gray-200 dark:border-gray-700 flex flex-col animate-in slide-in-from-right duration-300`}
//       >
//         {/* Header */}
//         <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200 dark:border-gray-700">
//           <div>
//             <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
//               {title}
//             </h2>
//             {description && (
//               <p className="text-xs text-slate-400 dark:text-slate-400 mt-1">
//                 {description}
//               </p>
//             )}
//           </div>
//           <button
//             onClick={onClose}
//             className="text-slate-400 dark:text-slate-300 hover:text-slate-600 dark:hover:text-white text-2xl p-2 transition-colors"
//           >
//             &times;
//           </button>
//         </div>

//         {/* Body */}
//         <div className="flex-1 p-6 overflow-y-auto">
//           {children}
//         </div>

//         {/* Footer */}
//         {footer && (
//           <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
//             {footer}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Drawer;



const Drawer = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  footer,
  width = "max-w-[400px]",
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[998] transition-opacity"
        // onClick={onClose}
      />

      {/* Drawer Panel */}
      <div
        className={`fixed inset-y-0 right-0 z-[999] flex w-full ${width} flex-col bg-white dark:bg-gray-900 shadow-2xl border-l border-gray-200 dark:border-gray-700 
        animate-in slide-in-from-right duration-300 ease-in-out
        /* FIX 1: Use h-full and overscroll-contain to prevent body scroll */
        h-full h-[100dvh] overscroll-contain`}
      >
        {/* Header */}
        <div className="flex-none flex items-center justify-between px-6 py-5 border-b border-gray-200 dark:border-gray-700 pt-[calc(env(safe-area-inset-top)+1.25rem)]">
          <div>
            <h2 className="text-lg font-black text-slate-800 dark:text-slate-100 uppercase tracking-tight">
              {title}
            </h2>
            {description && (
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1">
                {description}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-50 dark:bg-slate-800 text-slate-400 hover:text-orange-500 transition-colors"
          >
            &times;
          </button>
        </div>

        {/* Body - FIX 2: Added min-h-0 to allow flex shrinking */}
        <div className="flex-1 overflow-y-auto min-h-0 p-6 scrollbar-hide">
          {children}
        </div>

        {/* Footer - FIX 3: flex-none ensures it never shrinks or disappears */}
        {footer && (
          <div className="flex-none p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3 bg-white dark:bg-gray-900 pb-[calc(env(safe-area-inset-bottom)+1.5rem)]">
            {footer}
          </div>
        )}
      </div>
    </>
  );
};

export default Drawer;